'use strict';
import {ContactoRouteComponent} from './contacto-route.component.js';
import angular from 'angular';
import contactoService from './contaco.service';
const ngRoute = require('angular-route');

/*@ngInject*/
const routes = function($routeProvider){
    $routeProvider.when('/contacto', {
        template: '<contacto-route></contacto-route>',
        authenticate: true
    });

};

export default angular.module('pizzutoAutopartesApp.contacto', [ngRoute])
    .config(routes)
    .component(ContactoRouteComponent.selector, ContactoRouteComponent)
    .service('ContactoService', contactoService)
    .name;




// WEBPACK FOOTER //
// ./client/app/contacto-route/index.js